import React, { Component } from "react";
import { Row, Col, Button, Modal, Typography, Form, Statistic, Tag, message, Spin, Divider } from 'antd';
//componentes
import { PaperClipOutlined } from "@ant-design/icons"
import CustomAvatar from "../../../Widgets/Avatar/Avatar";

const { Title, Text } = Typography;
const axios = require('axios').default;
const moment = require('moment');



/**
 *
 *
 * @class ModalTransaccionesDetalle
 * @extends {Component}
 */
class ModalTransaccionesDetalle extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            transaccion: {
                _id: 0,
                concepto: '',
                proyecto_id: {
                    nombre: ''
                },
                cuenta_id: {
                    nombre: ''
                },
                cuenta_destino_id: {
                    nombre: ''
                },
                monto: 0,
                fecha: new Date(),

                tipo: 0,

                usuario_id: {
                    nombre: ''
                },
                area_id: {
                    nombre: ''
                },
                rubro_id: {
                    nombre: ''
                },
                descripcion: '',
                comprobantes: [],
                actualiza_saldo: false,
                tipo_cliente: 'transaccion-especie',
                descripcion: '',

                proveedor_id: {
                    nombre: ''
                },
                facturas: [{
                    factura_id: {

                    },
                    monto_abonado: 0
                }],

                inversion_id: {
                },
            },
        }

    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.getTransaccion(this.props.id)
    }


    componentDidUpdate() {
        //Si se abre el modal y el editar esa desactivo, se activa para poder editar
        if (this.props.modalVisible && !this.state.updateChecker && !(this.props.registroId == null || this.props.registroId == undefined)) {
            this.state.updateChecker = true;
            this.state.registroId = this.props.registroId;
            if (this.props.registroId !== null) {
                this.state.edicion = true;
                this.getTransaccion()
            }
        }

    }

    /**
    * @memberof ModalTran
    * @method getTransaccion
    * @description Obtiene la informacion de la transacciones para el modal de detalle. Actualiza el state
    * con informacion obtenida.
    */
    getTransaccion = (id) => {
        this.setState({ loading: true })
        axios.post('/transacciones/get', {
            id: id,
        }).then((transaccion) => {

            const data = transaccion.data.data;

            this.setState({ transaccion: data });
        })
            .catch(error => {
                console.log('error', error.response)
            })
            .finally(() => {
                this.setState({ loading: false })
            })

    }

    render() {
        const { transaccion } = this.state;
        console.log('transaccion', transaccion);

        return (
            <Form layout="vertical"   >
                <Title level={3} className="text-center">Detalle Transacción </Title>
                <Spin spinning={false}>
                    <Row justify="center" gutter={[24,8]}>
                        <Col xs={24} lg={11}>
                            <Form.Item label="Concepto" >
                                <Text type="secondary" >{transaccion.concepto}</Text>
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={11}>
                            <Form.Item label="Fecha" >
                                <Text type="secondary" >{moment(transaccion.fecha).format('LL')}</Text>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="center" gutter={[24,8]}>
                        {transaccion.area_id ? <Col xs={24} lg={11}>
                            <Form.Item label="Area" >
                                <Text type="secondary" >{transaccion.area_id?.nombre}</Text>
                            </Form.Item>
                        </Col>: null}
                        {transaccion.rubro_id ? <Col xs={24} lg={11}>
                            <Form.Item label="Rubro" >
                                <Text type="secondary" >{transaccion.rubro_id?.nombre}</Text>
                            </Form.Item>
                        </Col> : null}
                    </Row>
                    <Row justify="center" gutter={[24,8]}>
                        <Col xs={24} lg={{ span: 11, }}>
                            <Form.Item label="Cuenta" >
                                {(transaccion.actualiza_saldo === true) ? <Tag color="#87d068" className="tag-actualiza-saldo" >Actualiza Saldo</Tag> : null}
                                <Text type="secondary" > <CustomAvatar name={transaccion.cuenta_id.nombre} /> {transaccion.cuenta_id.nombre}</Text>
                            </Form.Item>
                        </Col>

                        <Col xs={24} lg={11}>
                            <Form.Item label="Tipo" >
                                <Text type="secondary" >{
                                    (transaccion.tipo != 3) ? ((transaccion.tipo == 1) ? 'Ingreso' : 'Egreso') : 'Traspaso'}
                                </Text>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="center" gutter={[24,8]}>

                        <Col xs={24} lg={{ span: 11 }}>
                            <Form.Item label="Monto" >
                                {(transaccion.tipo == 2) ?
                                    <Statistic
                                        value={transaccion.monto}
                                        valueStyle={{ fontSize: '16px', fontWeight: 'bold', color: '#FF0000' }}
                                        prefix={'$'}
                                        suffix={'MXN'}
                                    /> :
                                    <Statistic
                                        value={transaccion.monto}
                                        valueStyle={{ fontSize: '16px', fontWeight: 'bold', color: '#00FF19' }}
                                        prefix={'$'}
                                        suffix={'MXN'}
                                    />
                                }
                            </Form.Item>
                        </Col>

                        <Col xs={24} lg={11}>
                            <Form.Item label="Cliente" >
                                {(transaccion.cliente_id?.nombre !== undefined || transaccion.cliente_id?.razon_social) ? 
                                    <div>
                                        <CustomAvatar name={transaccion.cliente_id?.razon_social || transaccion.cliente_id?.nombre} size="small" style={{ marginRight: '5px' }} />
                                        {transaccion.cliente_id?.razon_social || transaccion.cliente_id?.nombre}
                                    </div>
                                :null}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="center" gutter={[24,8]}>
                        {transaccion.orden_id ? <Col xs={24} lg={{ span: 11 }} >
                            <Form.Item label="Folio Orden" >
                                <Text type="secondary" >
                                    {transaccion.orden_id?.folio}
                                </Text>
                            </Form.Item> 
                        </Col> : null}
                        {transaccion.clasificadores?.length > 0 ? <Col xs={24} lg={{ span: 12 }} >
                            <Form.Item label="Modulos" >
                                {transaccion.clasificadores?.map(function ({ _id, nombre, color }, index) {
                                    return <Tag style={{
                                        border: '1px solid ' + color,
                                        borderRadius: 0,
                                        background: `rgba(${color},0.5)`,
                                        color: color
                                    }}>{nombre}</Tag>
                                })}
                            </Form.Item>
                        </Col>: null}
                    </Row>
                    <Row justify="center" gutter={[24,8]}>
                        {transaccion.comprobantes?.length > 0 ? <Col xs={24} lg={22}>
                            <Form.Item label="Comprobantes" >
                                {transaccion.comprobantes?.map((imagen, index) => {
                                    return <Button type="link" icon={<PaperClipOutlined />} to={axios.defaults.baseURL + '/voucher/' + imagen}>{imagen}</Button>
                                })}
                            </Form.Item>
                        </Col> : null }


                        <Divider />
                        <Col xs={24} lg={{span: transaccion.editado_por?.length > 0 ? 11 : 22}}>
                            <Form.Item label="Autor" name="usuario_id">
                                <div>
                                    <CustomAvatar name={`${transaccion.usuario_id?.nombre} ${transaccion.usuario_id?.apellido}`} size="small" style={{ marginRight: '5px' }} />
                                    {`${transaccion.usuario_id?.nombre} ${transaccion.usuario_id?.apellido ? transaccion.usuario_id?.apellido : ''}`}
                                </div>
                            </Form.Item>
                        </Col>
                        {transaccion.editado_por?.length > 0 ? <Col xs={24} lg={{ span: 11 }}>
                            <Form.Item label="Editores" name="editado_por">
                                {transaccion.editado_por?.map(function ({ _id, nombre, apellido }, index) {
                                    return <div>
                                        <CustomAvatar name={`${nombre} ${apellido}`} size="small" style={{ marginRight: '5px' }} />
                                        {`${nombre} ${apellido}`}
                                    </div>
                                })}
                            </Form.Item>
                        </Col> : null}
                    </Row>
                </Spin>
            </Form>
        )
    }
}



export default function (props) {
    const { visible = false, onClose = () => { } } = props

    return <Modal
        visible={visible}
        onCancel={onClose}
        title={null}
        footer={null}
        closable={true}
        destroyOnClose={true}
        zIndex={1000}
    >
        <ModalTransaccionesDetalle {...props} />
    </Modal>

}